export default {
  root: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  input: {
    paddingBottom: 8,
    paddingTop: 4,
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
};
